module.exports = __webpack_public_path__ + "static/media/mod-willy.edf5a48a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/mod-willy.jpg
// module id = 342
// module chunks = 0